import * as React from "react";

function UpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "UpOutline-UpOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "UpOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11219264,30.7053818 L22.6612572,12.5234393 L22.6612572,12.5234393 C23.2125856,11.969699 24.0863155,11.9371261 24.6755735,12.4257204 L24.7825775,12.5234393 L42.8834676,30.7045714 C42.9580998,30.7795345 43,30.8810078 43,30.9867879 L43,34.1135102 C43,34.3344241 42.8209139,34.5135102 42.6,34.5135102 C42.4936115,34.5135102 42.391606,34.4711279 42.316542,34.3957362 L23.7816937,15.7799842 L23.7816937,15.7799842 L5.6866816,34.3764658 C5.53262122,34.5347957 5.27937888,34.5382568 5.121049,34.3841964 C5.04365775,34.3088921 5,34.205497 5,34.0975148 L5,30.9831711 C5,30.8795372 5.04022164,30.7799483 5.11219264,30.7053818 Z",
    id: "UpOutline-up",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default UpOutline;